import { billerPermissionsNavBarLinks, careChecklistPermissionsNavBarLinks, chartPermissionsNavBarLinks, documentsPermissionsNavBarLinks, flowsheetsPermissionsNavBarLinks, labsPermissionsNavBarLinks, notesPermissionsNavBarLinks, recallPermissionsNavBarLinks, } from '../constants';
// In the event that a js error triggers the ChartNavBar error boundary, return all links to ensure users are unblocked
export var getNavBarErrorLinks = function () {
    var linksArray = [];
    try {
        linksArray.push.apply(linksArray, chartPermissionsNavBarLinks);
        linksArray.push.apply(linksArray, notesPermissionsNavBarLinks);
        linksArray.push.apply(linksArray, labsPermissionsNavBarLinks);
        linksArray.push.apply(linksArray, flowsheetsPermissionsNavBarLinks);
        linksArray.push.apply(linksArray, billerPermissionsNavBarLinks);
        linksArray.push.apply(linksArray, careChecklistPermissionsNavBarLinks);
        linksArray.push.apply(linksArray, documentsPermissionsNavBarLinks);
        linksArray.push.apply(linksArray, recallPermissionsNavBarLinks);
    }
    catch (error) {
        throw new Error('navBarHelper - Error getting navbar links');
    }
    return linksArray;
};
